import { useRef } from 'react';

/*
    useArrayRef hook allows you to pass an array of refs to the gsap function in
    order to animate several elements at once.
*/
const useArrayRef = () => {
    const refs = useRef([]);
    refs.current = [];

    return [refs, (ref) => ref && refs.current.push(ref)];
};

export default useArrayRef;
